import { SiteNavigation, type SiteNavigationVariant } from "@replicate/ui";
import Cookies from "js-cookie";
import { useState } from "react";
import type { AccountWithAvatar } from "../types";
import AccountPicker from "./account-picker";
import { banner } from "./announcement";
import type { Theme } from "./dark-mode-toggle";
import { SiteSearch } from "./site-search";

export default function Navigation({
  activePath,
  isAuthenticated,
  variant = "floating",
  user,
  account,
  organizations,
  hasSuperpowers,
  theme,
  showSeedanceBanner,
}: {
  activePath: string;
  isAuthenticated: boolean;
  variant?: SiteNavigationVariant;
  user?: AccountWithAvatar;
  account?: AccountWithAvatar;
  organizations?: AccountWithAvatar[];
  hasSuperpowers: boolean;
  theme: Theme;
  showSeedanceBanner: boolean;
}) {
  const kind =
    account?.kind !== "anonymous"
      ? (account?.kind as "user" | "organization")
      : undefined;
  const username =
    account?.kind !== "anonymous" ? account?.username : undefined;

  const [showBanner, setShowBanner] = useState(showSeedanceBanner);

  const handleBannerDismiss = () => {
    setShowBanner(false);
    Cookies.set("replicate_hide_seedance_banner", "true", {
      expires: 365,
      secure: true,
      sameSite: "lax",
    });
  };

  return (
    <SiteNavigation
      showBanner={showBanner}
      onBannerDismiss={handleBannerDismiss}
      bannerText={banner.text}
      bannerMedia={banner.media}
      bannerHref={banner.href}
      bannerTarget={banner.target}
      variant={variant}
      avatar={
        isAuthenticated && user && account ? (
          <AccountPicker
            account={account}
            organizations={organizations || []}
            user={user}
            hasSuperpowers={hasSuperpowers}
            theme={theme}
          />
        ) : null
      }
      authState={isAuthenticated ? "authenticated" : "anonymous"}
      currentPath={activePath}
      meta={null}
      search={
        <div className="w-full max-w-lg">
          <SiteSearch
            authState={isAuthenticated ? "authenticated" : "anonymous"}
          />
        </div>
      }
      logo={"glyph"}
      kind={kind}
      username={username}
    />
  );
}
